import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { bulkUploadActions as actions, notificationActions } from '../actions';
import { bulkUploadService } from '../services';

/* bulkUpload Sagas */
function* handleBulkUploadRequest() {
  const action = yield take(actions.bulkUploadRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(bulkUploadService.bulkUpload, dataParams);
    if (res.isError) {
      yield put(actions.bulkUploadError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.bulkUploadSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.bulkUploadError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Download Bulk Upload Sample File Sagas */
function* handleDownloadBulkUploadSampleFileRequest() {
  const action = yield take(actions.downloadBulkUploadSampleFileRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(bulkUploadService.downloadBulkUploadSampleFile, dataParams);
    if (res.isError) {
      yield put(actions.downloadBulkUploadSampleFileError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.downloadBulkUploadSampleFileSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.downloadBulkUploadSampleFileError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* -----------Watchers------------- */
function* handleBulkUploadWatcher() {
  yield takeEvery(
    actions.bulkUploadRequest,
    handleBulkUploadRequest,
  );
}


function* handleDownloadBulkUploadSampleFileWatcher() {
  yield takeEvery(
    actions.downloadBulkUploadSampleFileRequest,
    handleDownloadBulkUploadSampleFileRequest,
  );
}


function* rootBulkUploadSaga() {
  yield all([
    handleBulkUploadRequest(),
    handleBulkUploadWatcher(),

    handleDownloadBulkUploadSampleFileRequest(),
    handleDownloadBulkUploadSampleFileWatcher(),
  ]);
}

export default rootBulkUploadSaga;
